import { authStore } from "../../stores/AuthStore";
import { useNavigate } from 'react-router-dom';

const Logout = () => {
	const navigate = useNavigate();

	const handleLogout = async () => {
		await authStore.logout();
		navigate('/');
	}

	return (
		<div className='center-content'>
			<button className='button' onClick={handleLogout}>Logout</button>
		</div>
	)
};

export default Logout; 